@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

@border-radius: 5px;

.service-group-selector {
  fill: var(--grey-600);
  cursor: pointer;

  &:hover,
  &:focus {
    fill: @fulfillment-planner--shipping-service-group--hover--fill-color;
  }
}

.service-group-selector-dropdown {
  display: flex;
  align-items: center;
}

.options-content {
  background-color: @fulfillment-planner--shipping-service-options--background-color;
  border: 1px solid @fulfillment-planner--shipping-service-options--border-color;
  border-radius: @border-radius;
  overflow: hidden;
  width: 225px;
  font-size: 12px;
  padding: 10px;
  box-shadow: 0 2px 4px @fulfillment-planner--shipping-service-options--box-shadow-color;

  .options {
    padding-bottom: 5px;

    .option {
      font-size: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0 5px;

      > label {
        padding-left: 5px;
      }

      &:hover {
        background-color: @fulfillment-planner--shipping-service-options--hover--background-color;
      }
    }
  }
}

.collections {
  padding-top: 5px;
  border-top: 1px solid @fulfillment-planner--shipping-service-collections--border-color;
  line-height: 14px;

  .service-collections-title {
    padding-bottom: 5px;
  }
}

.service-collections-title,
.options-title {
  font-size: 13px;
  font-weight: @bold;
  color: @fulfillment-planner--shipping-service-title--text-color;
}

.icon {
  height: 20px;
  width: 20px;
  padding: 5px;
  color: var(--grey-600);
}

.service-group-selector-dropdown-button {
  padding: @space-4;
  height: 24px;
}

.service-group-selector-dropdown-button-content {
  align-items: center;
  gap: @space-8;
}

.service-group-selector-dropdown-button-icon {
  width: 12px;
  height: 12px;
}
